module.exports = __webpack_public_path__ + "static/raender_klein-7453d4d082e2d47042c7fea7b48d7221.png";